import React, {useState} from 'react';
import {FeedStarterGuide} from './FeedStarterGuide';
import {BoosterActKicker} from '../flow/BoosterActKicker';
import {BOOSTER_STEP_FEED} from '../boosterSteps';
import {ContextPackRequestModal} from '../../memory/ContextPackRequestModal';
import {useContextPack} from '../../memory/useContextPack';

/**
 * La primera fila del acto Alimenta: el rótulo «01 · ALIMENTA», por qué importa lo que se carga y la
 * guía de qué material sirve (card wugYmCtZ, call con Leo de Bakián del 07/10).
 *
 * Hasta esa card la guía vivía DEBAJO del orbe y de la Barra Total, como un link de texto a la
 * derecha: Leo la encontró sólo porque fede le dijo dónde mirar, y pidió «arriba y más claro». Es
 * uno de los dos argumentos con los que la agencia empuja a sus equipos a cargar la memoria en
 * Dashbo: que Dashbo los oriente en QUÉ cargar.
 *
 * Es un componente aparte y no una parte de `FeedActContent` porque ahora vive ARRIBA del orbe, en
 * otra escena del acto, y el orbe lo dibuja `BoosterFeedHero` — hermano de los dos. Se llevó con él
 * lo que la guía usa: el Paquete de Contexto (qué material se le puede pedir al cliente, y si la
 * memoria está en cero) y el modal de «Pedir material». El refresco del pack lo pide el contenedor
 * con `refreshToken`, que sube en la misma transición a READY de antes (`handleDocumentReady`).
 */
export function FeedGuideBlock({clientId, clientName = '', onPickKind, refreshToken = 0}) {
    const {summary} = useContextPack(clientId, {refreshToken});
    const [requestOpen, setRequestOpen] = useState(false);

    return (
        <div className="iab-feed -top">
            {/* El rótulo del acto va acá: Alimenta no lleva encabezado. Lleva el `id` que la
                `<section>` referencia con `aria-labelledby` — sin él, el acto queda como una región
                sin nombre para un lector de pantalla. */}
            <FeedStarterGuide clientId={clientId} onPick={onPickKind} summary={summary}
                              onRequestMaterial={() => setRequestOpen(true)}
                              kicker={<BoosterActKicker stepKey={BOOSTER_STEP_FEED}
                                                        id={`${BOOSTER_STEP_FEED}-title`}/>}/>
            <ContextPackRequestModal
                isOpen={requestOpen}
                onClose={() => setRequestOpen(false)}
                clientName={clientName}
                missingItems={(summary && summary.requestableMissing) || []}
            />
        </div>
    );
}

export default FeedGuideBlock;
